/*
 * Produktseite: zwei Dinge, die nur im Browser zu lösen sind
 * ---------------------------------------------------------------------------
 * 1. App-Bausteine an ihren Platz holen
 * 2. Das Rabatt-Abzeichen an den tatsächlich gezeigten Preis binden
 *
 * Beides lässt sich weder im Theme-Editor noch in Liquid erledigen, weil
 * es von dem abhängt, was die Apps im Browser daraus machen.
 *
 * data-cookieconsent="ignore" am <script>-Tag ist Pflicht (siehe
 * snippets/html-bottom-js.liquid): Cookiebot hält Skripte ohne das
 * Attribut zurück und führt sie erst nach den defer-Skripten aus.
 */
(function () {
  "use strict";

  if (window.__skProductPage) return;
  window.__skProductPage = true;

  /* ==================================================== 1. Plätze ====== */

  /*
   * Zwei Apps setzen ihre Elemente selbst ins Dokument und lassen sich
   * dabei nicht umsortieren:
   *
   *   Wishlist King  hängt <wishlist-button-product> in die Titelzeile
   *                  und lässt den Knopf dort schwebend oben rechts
   *                  sitzen. Dort steht die Bewertungsnote — und der
   *                  Knopf gehört neben „In den Warenkorb“.
   *
   *   Kite Free Gift spritzt .gfgProductPageWrapperV2 an den Anfang des
   *                  Kauf-Formulars. Es hängt damit am „Buy buttons“-
   *                  Block und wandert im Theme-Editor nur mit ihm.
   *                  Unter die Lieferzusage kommt es nur so.
   *
   * Umgehängt wird jeweils nur der Platz im Dokument. Die Elemente
   * selbst, ihre Attribute und alles, was die Apps daran hängen, bleiben
   * unberührt. Fehlt ein Zielfeld, bleibt das Element, wo die App es
   * hingelegt hat — verloren geht nichts.
   */
  var MOVES = [
    { slot: "[data-sk-wishlist-slot]", element: ".product-info-col wishlist-button-product" },
    { slot: "[data-sk-gift-slot]", element: ".product-info-col .gfgProductPageWrapperV2" }
  ];

  function place() {
    for (var i = 0; i < MOVES.length; i++) {
      var slot = document.querySelector(MOVES[i].slot);
      if (!slot) continue;

      var element = document.querySelector(MOVES[i].element);
      if (!element || element.parentElement === slot) continue;

      slot.appendChild(element);
    }
  }

  /* ================================================== 2. Rabatt ======== */

  /*
   * Das Rabatt-Abzeichen an den Preis binden, der wirklich dasteht.
   *
   * Liquid rechnet aus Variantenpreis und Streichpreis — also aus dem
   * Einmalkauf. Wählt jemand eine Abo-Option, schreibt Appstle den Preis
   * im Browser um, und zwar so:
   *
   *   1. Es klont die Preiszeile des Themes, ersetzt den Inhalt durch den
   *      Abo-Preis und hängt den Klon davor.
   *   2. Es setzt am Original inline `text-decoration: line-through`.
   *
   * Aus diesem inline gesetzten Stil lassen sich die beiden Zeilen sauber
   * auseinanderhalten — ohne Klassennamen der App zu raten, die sich mit
   * dem nächsten App-Update ändern können:
   *
   *   ohne line-through  = der Betrag, der zu zahlen ist
   *   mit  line-through  = derselbe Artikel ohne Abo
   *
   * Gerechnet wird weiterhin nur mit dem, was auf dem Bildschirm steht.
   * Welche App den Preis zuletzt angefasst hat, spielt damit keine Rolle.
   */
  var PRICE_WRAPPER = ".product-info-col .product__price-wrapper";
  var COMPARE = ".price__item--compare";
  var BADGES = [
    ".product-info-col .product-price__discount-badge",
    ".product-media .badge--sale"
  ];

  /* "1.234,56 €" und "€45,78" -> Zahl. Ohne Treffer null. */
  function toNumber(text) {
    var match = String(text).replace(/\s/g, "").match(/(\d{1,3}(?:\.\d{3})+|\d+),(\d{1,2})/);
    if (!match) return null;
    return parseFloat(match[1].replace(/\./g, "") + "." + match[2]);
  }

  function money(value) {
    return value.toFixed(2).replace(".", ",") + " €";
  }

  function isVisible(element) {
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  /*
   * Der prominenteste Betrag in einer Preiszeile: das sichtbare Element
   * ohne Kindelemente mit der größten Schrift. Nur Elemente ohne Kinder,
   * sonst zählte jede umschließende Hülle denselben Betrag noch einmal.
   *
   * Appstles Klon trägt seinen Betrag als direktes Textkind und hat gar
   * keine Elemente — dafür der Rückfall auf den Text der Zeile selbst.
   */
  function pickAmount(line) {
    if (!line) return null;

    var nodes = line.querySelectorAll("*");
    var best = null;
    var bestSize = -1;

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.children.length) continue;
      var value = toNumber(node.textContent);
      if (value === null || !isVisible(node)) continue;

      var size = parseFloat(window.getComputedStyle(node).fontSize) || 0;
      if (size <= bestSize) continue;

      bestSize = size;
      best = { value: value, text: node.textContent.trim() };
    }

    if (best) return best;

    var fallback = toNumber(line.textContent);
    return fallback === null ? null : { value: fallback, text: line.textContent.trim() };
  }

  function setBadge(text) {
    for (var i = 0; i < BADGES.length; i++) {
      var badge = document.querySelector(BADGES[i]);
      if (!badge) continue;

      if (text === null) {
        badge.hidden = true;
        continue;
      }

      badge.hidden = false;
      /* Nur schreiben, wenn sich etwas ändert — sonst löst der eigene
         Schreibvorgang den Beobachter unten endlos neu aus. */
      if (badge.textContent.trim() !== text) badge.textContent = text;
    }
  }

  /*
   * Die mitlaufende Kaufleiste am unteren Rand schreibt den Preis ab, der
   * oben steht — Betrag, Streichpreis und eine kurze Zweitzeile. Eine
   * zweite Preisrechnung gäbe es sonst an zwei Stellen, und die eine
   * liefe früher oder später der anderen davon.
   */
  function syncStickyPrice(amountText, compareText, noteText) {
    var amount = document.querySelector("[data-sk-sticky-amount]");
    if (!amount) return;

    if (amountText && amount.textContent.trim() !== amountText) {
      amount.textContent = amountText;
    }

    var compare = document.querySelector("[data-sk-sticky-compare]");
    if (compare) {
      if (compareText) {
        if (compare.textContent.trim() !== compareText) compare.textContent = compareText;
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }
    }

    var note = document.querySelector("[data-sk-sticky-note]");
    if (note) {
      if (noteText) {
        if (note.textContent.trim() !== noteText) note.textContent = noteText;
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }
  }

  function syncDiscount() {
    var wrapper = document.querySelector(PRICE_WRAPPER);
    if (!wrapper) return;

    var lines = wrapper.querySelectorAll(".price");
    var current = null;
    var struck = null;

    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      if (!isVisible(line)) continue;

      if ((line.getAttribute("style") || "").indexOf("line-through") > -1) {
        struck = line;
      } else {
        current = line;
      }
    }

    if (!current) return;

    var currentPick = pickAmount(current);
    if (currentPick === null) return;
    var price = currentPick.value;

    /* ---- Abo gewählt ---------------------------------------------- */
    if (struck) {
      var struckPick = pickAmount(struck);
      var oneTime = struckPick === null ? null : struckPick.value;
      if (oneTime === null || oneTime <= price) {
        setBadge(null);
        syncStickyPrice(currentPick.text, null, null);
        return;
      }

      /*
       * Liegt unter dem Einmalpreis noch eine UVP, treffen zwei Rabatte
       * aufeinander. Dann steht im Abzeichen ein Eurobetrag statt einer
       * Prozentzahl: −15 % Aktion und −5 % Abo ergeben zusammen −19 %,
       * nicht −20 %, und wer das liest, rechnet nach. Ein Eurobetrag ist
       * die Differenz zweier Zahlen und braucht keine Erklärung.
       *
       * Der Streichpreis ist per CSS ausgeblendet, steht aber im
       * Dokument — deshalb hier ohne Sichtbarkeitsprüfung gelesen.
       */
      var compareNode = struck.querySelector(COMPARE);
      var compare = compareNode ? toNumber(compareNode.textContent) : null;

      if (compare && compare > oneTime) {
        var saving = "Du sparst " + money(compare - price);
        setBadge(saving);
        syncStickyPrice(currentPick.text, struckPick.text, saving);
        return;
      }

      var subPercent = Math.round((1 - price / oneTime) * 100);
      var subBadge = subPercent > 0 ? "−" + subPercent + " %" : null;
      setBadge(subBadge);
      syncStickyPrice(currentPick.text, struckPick.text, subBadge ? "Abo · " + subBadge : null);
      return;
    }

    /* ---- Einmalkauf ----------------------------------------------- */
    var saleCompare = current.querySelector(COMPARE);
    if (!saleCompare || !isVisible(saleCompare)) {
      setBadge(null);
      syncStickyPrice(currentPick.text, null, null);
      return;
    }

    var reference = toNumber(saleCompare.textContent);
    if (!reference || reference <= price) {
      setBadge(null);
      syncStickyPrice(currentPick.text, null, null);
      return;
    }

    var percent = Math.round((1 - price / reference) * 100);
    var badge = percent > 0 ? "−" + percent + " %" : null;
    setBadge(badge);
    syncStickyPrice(currentPick.text, saleCompare.textContent.trim(), badge);
  }

  /* ============================================ 3. Galerie „+N“ ======== */

  /*
   * Die Vorschaubild-Reihe ist wischbar, aber am Rechner sieht man das
   * nicht. Die Kachel „+N“ am rechten Ende sagt, wieviele Bilder noch
   * kommen, und öffnet die Lightbox beim ersten davon.
   *
   * Wieviele Kacheln in die Reihe passen, weiß erst der Browser: Swiper
   * rechnet die Breite selbst aus, und sie hängt an der Spaltenbreite.
   * Deshalb wird hier gemessen statt in Liquid gezählt. Gemessen wird
   * beim Laden und bei Breitenänderung — nicht beim Wischen: sonst
   * zählte die Kachel beim Schieben herunter und verschwände am Ende,
   * und die Reihe würde vor den Augen des Lesers schmaler.
   */
  var MORE_BUTTON = "[data-sk-more-media]";
  var moreMeasuredWidth = -1;

  function syncMoreMedia(force) {
    var button = document.querySelector(MORE_BUTTON);
    if (!button) return;

    var row = button.parentElement;
    var viewport = row.querySelector("[data-product-media-thumbnails-slider]");
    if (!viewport) return;

    /*
     * Erst messen, wenn Swiper fertig ist.
     *
     * Vorher ist eine „Kachel“ ein gewöhnliches Block-Element und damit
     * so breit wie die ganze Zeile. Wer in diesem Moment misst, bekommt
     * „eine Kachel passt, sieben fehlen“ — und wenn er daraufhin die
     * Kachel „+N“ auf Kachelbreite setzt, nimmt sie die ganze Zeile ein,
     * der Slider daneben bleibt 0 px breit und Swiper rechnet
     * anschließend 2-px-Kacheln aus. Die Messung zerstörte also genau
     * das Layout, das sie vermessen wollte.
     */
    if (!viewport.classList.contains("swiper-initialized")) {
      moreMeasuredWidth = -1;
      return;
    }

    var slides = viewport.querySelectorAll(".swiper-slide");
    if (slides.length < 2) return;

    var frame = viewport.getBoundingClientRect();
    if (frame.width < 40) {
      moreMeasuredWidth = -1;
      return;
    }

    /* Ohne erzwungene Neumessung nur rechnen, wenn sich die Breite
       wirklich geändert hat — der Beobachter unten feuert bei jedem
       eingefügten Knoten, und getBoundingClientRect ist nicht gratis. */
    if (!force && Math.abs(frame.width - moreMeasuredWidth) < 1) return;
    moreMeasuredWidth = frame.width;

    /* Zweite Sicherung: eine Kachel ist klein und deutlich schmaler als
       die Reihe. Alles andere ist ein Zwischenzustand, kein Messwert. */
    var tile = slides[0].getBoundingClientRect();
    if (tile.width < 24 || tile.width > frame.width * 0.9) {
      moreMeasuredWidth = -1;
      return;
    }

    /* 8 px ist der Abstand, den Swiper zwischen den Kacheln setzt
       (spaceBetween in assets/product-media-slider.js). */
    var gap = 8;
    var fits = Math.max(1, Math.round((frame.width + gap) / (tile.width + gap)));
    var rest = slides.length - fits;

    /* Die Maße der Kachel stehen im CSS und werden hier bewusst nicht
       angefasst — sie zu setzen hieße, an der Breite zu drehen, aus der
       diese Messung stammt. Hier wird nur gezählt. */
    if (rest < 1) {
      button.hidden = true;
      return;
    }

    var wasHidden = button.hidden;
    button.hidden = false;

    /*
     * Solange die Kachel ausgeblendet ist, steht sie auf display:none und
     * nimmt keinen Platz ein — Swiper hat die Kachelbreiten also aus der
     * vollen Reihe gerechnet. Nach dem Einblenden fehlen ihm die
     * reservierten Pixel; ohne diesen Anstoß bleiben die Vorschaubilder
     * zu breit und ragen unter der Kachel durch.
     *
     * update() ist Swipers eigener Weg dafür und rührt an nichts anderem.
     * Danach stimmen die Maße, und der nächste Durchlauf zählt neu.
     */
    if (wasHidden && viewport.swiper && typeof viewport.swiper.update === "function") {
      viewport.swiper.update();
      moreMeasuredWidth = -1;
      setTimeout(function () { syncMoreMedia(true); }, 0);
      return;
    }

    button.dataset.skMoreMediaIndex = String(fits);

    var label = button.querySelector("[data-sk-more-media-count]");
    var text = "+" + rest;
    if (label && label.textContent !== text) label.textContent = text;
  }

  /*
   * Geklickt wird nicht die Kachel selbst, sondern das Bild im großen
   * Slider: dort hängt Fancybox schon dran. So gibt es nur eine Stelle,
   * an der die Lightbox geöffnet wird, und die Galerie bleibt
   * vollständig — die Kachel legt nur fest, bei welchem Bild sie aufgeht.
   */
  function openMoreMedia(event) {
    var button = event.target.closest && event.target.closest(MORE_BUTTON);
    if (!button) return;

    event.preventDefault();

    var start = parseInt(button.dataset.skMoreMediaIndex, 10);
    if (!(start > 0)) start = 0;

    var slides = document.querySelectorAll("[data-product-media-slider] .swiper-slide");
    for (var i = start; i < slides.length; i++) {
      var target = slides[i].querySelector("[data-fancybox]");
      if (target) {
        target.click();
        return;
      }
    }

    /* Hinter der Startkachel liegt nur noch Video oder 3D — dann eben
       beim ersten Bild öffnen, statt gar nichts zu tun. */
    var first = document.querySelector("[data-product-media-slider] [data-fancybox]");
    if (first) first.click();
  }

  /* ======================================= 4. Zu den Bewertungen ======= */

  /*
   * Kein JavaScript nötig: die Bewertungszeile ist ein gewöhnlicher
   * Anker auf #judgeme_product_reviews. Weich rollt der Browser von
   * selbst (html { scroll-behavior: smooth } steht im Theme), und den
   * Abstand zur klebenden Kopfzeile hält scroll-margin-top in
   * section-main-product.css.
   *
   * Hier stand kurzzeitig ein eigener Handler mit scrollIntoView. Er ist
   * wieder raus: er hätte gegenüber dem Anker nichts gekonnt, aber jedes
   * Hindernis geerbt, das programmatisches Scrollen blockiert (ein
   * offenes Popup mit Scroll-Sperre zum Beispiel). Der Anker gilt auch
   * ohne JavaScript und auch von außen verlinkt.
   */

  /* ================================ 5. Platzhalter Kaufoptionen ======== */

  /*
   * Nimmt den reservierten Platz weg, sobald der Kaufoptionen-Kasten
   * wirklich darin steht.
   *
   * Liquid reserviert ihn bei jedem Produkt mit Abo (siehe „Platzhalter
   * Kaufoptionen" in sections/main-product.liquid). Gemessen wird nicht,
   * ob ein bestimmtes App-Element auftaucht, sondern ob im Feld
   * überhaupt etwas mit Höhe steht — dadurch hängt hier kein
   * Klassenname einer App drin, der beim nächsten Update anders heißt,
   * und ein anderer App-Block an derselben Stelle räumt den Platzhalter
   * genauso weg.
   *
   * Die Notbremse nach 8 Sekunden ist für den Fall, dass die App gar
   * nicht lädt (Blocker, Netzwerkfehler). Dann klappt der Kasten
   * zusammen — ein Sprung, aber ein einmaliger; ein dauerhaft
   * schimmernder leerer Kasten wäre schlimmer.
   */
  function watchAppSlot() {
    var slot = document.querySelector("[data-sk-app-slot]");
    if (!slot || !slot.classList.contains("is-awaiting")) return;

    var GIVE_UP_MS = 8000;
    var startedAt = Date.now();
    var observer = null;
    var ticker = null;

    function filled() {
      var nodes = slot.querySelectorAll("*");
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].offsetHeight > 0) return true;
      }
      return false;
    }

    function release() {
      slot.classList.remove("is-awaiting");
      if (observer) observer.disconnect();
      if (ticker) clearInterval(ticker);
    }

    if (filled()) return release();

    ticker = setInterval(function () {
      if (filled() || Date.now() - startedAt >= GIVE_UP_MS) release();
    }, 80);

    if (window.MutationObserver) {
      observer = new MutationObserver(function () {
        if (filled()) release();
      });
      observer.observe(slot, { childList: true, subtree: true });
    }
  }

  /* =================================================== Auslöser ======== */

  function refresh() {
    place();
    syncDiscount();
    syncMoreMedia(false);
  }

  function start() {
    refresh();
    watchAppSlot();

    document.addEventListener("click", openMoreMedia, true);

    /* Swiper wird als Modul nachgeladen; vorher haben die Kacheln noch
       keine Breite. Zweimal nachfassen reicht — danach hält der
       Beobachter unten die Zahl aktuell. */
    setTimeout(function () { syncMoreMedia(true); }, 250);
    setTimeout(function () { syncMoreMedia(true); }, 1000);
    window.addEventListener("resize", function () { syncMoreMedia(true); });

    if (!window.MutationObserver) return;

    /*
     * Weit gespannt, aber billig: geprüft werden nur eingefügte Knoten.
     * Deckt das späte Laden beider Apps ab.
     */
    new MutationObserver(refresh).observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    /*
     * Eng gespannt und dafür gründlich: Appstle blendet die Preiszeile
     * des Themes per style="display:none" aus und setzt seine eigene
     * daneben — eine Attributänderung, die der Beobachter oben nicht
     * sieht. Der Preisblock selbst bleibt bestehen, deshalb genügt ein
     * Beobachter darauf.
     */
    var wrapper = document.querySelector(PRICE_WRAPPER);
    if (wrapper) {
      new MutationObserver(syncDiscount).observe(wrapper, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["style", "class"]
      });
    }

    /* Der eigentliche Auslöser beim Umschalten der Kaufoption. Appstle
       rechnet erst nach dem Klick, deshalb zweimal nachfassen. */
    document.addEventListener(
      "change",
      function (event) {
        var input = event.target;
        if (!input || !input.name || input.name !== "selling_plan") return;
        setTimeout(syncDiscount, 0);
        setTimeout(syncDiscount, 400);
      },
      true
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
